/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import "bootstrap-css-only/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../../../src/assets/mdbreact/scss/mdb-free.scss";
import "react-multi-carousel/lib/styles.css";
import "../../components/Css/index.css";

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";

import Avisos from "../../components/Headers/Avisos/Avisos";
import MainNavbar from "../../components/MainNavbar/MainNavbar";
import Footer from "../../components/Footer/Footer";
import { GGgetMode } from "../../services/gglocalstorage";
import { getConsent, saveConsent } from "../../services/consentManager";
function FeevaleCookieNotice() {
  const [visible, setVisible] = useState(false);
  const [hasChoice, setHasChoice] = useState(false);
  const [personalizing, setPersonalizing] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [tagManager, setTagManager] = useState(false);

  useEffect(() => {
    const existing = getConsent();
    setHasChoice(Boolean(existing));
    setVisible(!existing);
  }, []);

  function savePreferences(allowAnalytics, allowMarketing) {
    saveConsent({ analytics: allowAnalytics, marketing: allowMarketing });
    setHasChoice(true);
    setVisible(false);
    setPersonalizing(false);
  }

  function reopenPreferences() {
    const saved = getConsent();
    setAnalytics(saved ? saved.analytics : false);
    setTagManager(saved ? saved.marketing : false);
    setPersonalizing(true);
    setVisible(true);
  }

  if (!visible) {
    return hasChoice ? (
      <button type="button" className="reabrirCookies" onClick={reopenPreferences}>
        Preferências de cookies
      </button>
    ) : null;
  }

  return (
    <section className="avisoCookies" aria-label="Preferências de cookies">
      <div className="conteudoAvisoCookies">
        <p className="textoAvisoCookies">
          Utilizamos cookies para garantir o funcionamento do site e, com sua autorização,
          analisar a navegação e medir ações de marketing, personalizar a oferta de cursos e
          recomendar conteúdos do seu interesse. Saiba mais na{" "}
          <a
            href="https://www.feevale.br/Comum/midias/edc6b2f3-c93b-4a4e-8c4b-baade462310e/PoliticaPrivacidade_institucional.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Política de Privacidade
          </a>.
        </p>
        {personalizing && (
          <div className="preferenciasCookies">
            <label className="opcaoCookies">
              <input type="checkbox" checked disabled />
              <span><strong>Cookies necessários</strong> — obrigatórios para o funcionamento do site.</span>
            </label>
            <label className="opcaoCookies">
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />
              <span><strong>Análise de navegação</strong> — Google Analytics 4 e estatísticas de uso.</span>
            </label>
            <label className="opcaoCookies">
              <input type="checkbox" checked={tagManager} onChange={(e) => setTagManager(e.target.checked)} />
              <span><strong>Marketing e personalização</strong> — GTM, anúncios e ferramentas de marketing.</span>
            </label>
          </div>
        )}
      </div>
      <div className="btnAvisoCookies">
        <button type="button" className="btnAcceptCookies" onClick={() => savePreferences(true, true)}>
          Aceitar todos
        </button>
        <button type="button" className="btnDeclineCookies" onClick={() => savePreferences(false, false)}>
          Recusar opcionais
        </button>
        {personalizing ? (
          <button type="button" className="btnPersonalizarCookies" onClick={() => savePreferences(analytics, tagManager)}>
            Salvar preferências
          </button>
        ) : (
          <button type="button" className="btnPersonalizarCookies" onClick={() => setPersonalizing(true)}>
            Personalizar
          </button>
        )}
      </div>
    </section>
  );
}

export default function Layout({ children, color }) {
	Layout.propTypes = {
		children: PropTypes.object.isRequired,
	};

	useEffect(() => {
    if (process.env.NODE_ENV !== "production" || typeof document === "undefined") return;
    // Ferramenta de acessibilidade — carregada apenas uma vez.
    if (document.getElementById("feevale-handtalk")) return;
    const script = document.createElement("script");
    script.id = "feevale-handtalk";
    script.src = "https://plugin.handtalk.me/web/latest/handtalk.min.js";
    script.async = true;
    script.onload = () => {
      if (window.HT) new window.HT({
        token: "67d8ad24f158ff8b093ac95c14fb6b67",
        maxTextSize: 1000,
        pageSpeech: true
      });
    };
    document.body.appendChild(script);
  }, []);

	// TODO: ISSUE01 Revisar lógica de escape para licenciaturas e conheca-a-feevale-way
	return (
		<>
			<customCSS />
			<Avisos />
			<MainNavbar />
			<MDBContainer
				fluid
				style={{
					backgroundColor:
						GGgetMode() &&
						typeof window !== "undefined" &&
						!(
							window.location.pathname.startsWith("/licenciaturas") ||
							window.location.pathname.startsWith("/conheca-a-feevale-way")
						) &&
						"#080f07",
				}}
			>
				<MDBRow className="pb-5" style={{ backgroundColor: color }}>
					<MDBCol style={{ paddingLeft: 0, paddingRight: 0 }}>
						{children}
					</MDBCol>
				</MDBRow>
				<FeevaleCookieNotice />
			</MDBContainer>
			{/* Botão Flutuante */}
			<MDBBtn
				tag="a"
				href="https://api.whatsapp.com/send/?phone=555135868800&text&type=phone_number&app_absent=0"
				target="_blank"
				color="white"
				floating
				style={{
					position: "fixed",
					bottom: "20px",
					right: "20px",
					zIndex: 1050,
					width: "60px",
					height: "60px",
					borderRadius: "50%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "0",
				}}
			>
				<MDBIcon fab icon="whatsapp" style={{ color: "#5ba82d" }} size="3x" />
			</MDBBtn>
			<Footer />
		</>
	);
}
